<template>
  <div class="cpnt-app-geral cpnt-app-calendario cpnt-app-campo" :class='cpntCalendarioMontarClass' v-show="cpntMostrar">
    <!-- <input :id="cpntId" type="text" ref="input" :value="value" :tabIndex='cpntTabIndex' :disabled="cpntDisabled"> -->
    <the-mask
    :masked='true' 
    :tabIndex='cpntTabIndex'
    :mask="[ '##/##/####' ]"
    :id='cpntId'
    :disabled="cpntDisabled"
    :maxlength="10"
    v-model='value'
    ref="input"
    @blur.native='cpntCalendarioOnBlur'
    ></the-mask>
    
    <!-- SETA O ICONE DE CARREGANDO -->
    <div v-if="loading === true" class="cpnt-app-toggle-loading" title="Carregando...">
      <svg class="fas fa-spinner fa-spin"></svg>
    </div>

    <!-- SETA A BARRA QUE APRESENTA ABAIXO DO INPUT -->
    <span class="cpnt-barra"></span>
    
    <!-- SETA O TITULO DO CAMPO -->
    <label :for='cpntId' v-if="[ '', null, undefined ].indexOf(cpntNome) === -1 || [ '', null, undefined ].indexOf(cpntExplica) === -1">
      <!-- SETA O NOME DO CAMPO -->
      <span v-if="[ '', null, undefined ].indexOf(cpntNome) === -1" v-html='cpntNome'></span>

      <!-- SETA A EXPLICAÇÃO DO CAMPO -->
      <App-Explica v-if="[ '', null, undefined ].indexOf(cpntExplica) === -1"
        :cpntId='cpntId + "-explica"' 
        :cpntTitle='cpntExplica.mensagem'
        :cpntPositionMy='cpntExplica.posicaoMy'
        :cpntPositionAt='cpntExplica.posicaoAt'
        :cpntClasses='cpntExplica.class'
      ></App-Explica>
    </label>

    <!-- SETA UM AVISO ABAIXO DO CAMPO -->
    <span class="cpnt-has-error" v-if="[ '', null, undefined ].indexOf(cpntMensagem) === -1" v-html='cpntMensagem'></span>
  </div>
</template>

<style>
.datepick-popup {
  z-index: 100000 !important;
}
</style>

<style>
</style>

<script>
  import '../../../node_modules/kbw-datepick/dist/css/jquery.datepick.css'
  import '../../../node_modules/kbw-datepick/dist/js/jquery.plugin.min.js'
  import '../../../node_modules/kbw-datepick/dist/js/jquery.datepick.min.js'
  import '../../../node_modules/kbw-datepick/dist/js/jquery.datepick-pt-BR.js'

  import { TheMask } from 'vue-the-mask'

  export default {
    props: {
      cpntStatus: {
        required: true
      },
      cpntId: {
        required: false,
        type: String,
        default: function () {
          // INICIA A VARIAVEL ID
          var id = ''

          // INICIA PARA VERIFICAR SE ENCONTROU UM ID
          var flag = false

          // PROCURAR A MONTAGEM DO CAMPO
          while (flag === false) {
            // GERA UM ID PARA O CAMPO
            id = 'cpnt-input-' + (Math.floor(Math.random() * (9999 - 1000)) + 1000).toString() + '--'

            // VERIFICA SE O ID GERADO É UNICO NA TELA
            flag = [ '', null, undefined ].indexOf(document.getElementById(id)) !== -1
          }

          // RETONAR O VALOR MONTADO
          return id
        }
      },
      cpntNome: {
        required: true,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntValue: {
        required: true,
        type: String
      },
      cpntTabIndex: {
        required: false,
        type: Number,
        default: function () {
          return 0
        }
      },
      cpntDisabled: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMostrar: {
        type: Boolean,
        required: false,
        default: function () {
          return true
        }
      },
      cpntAutoFocus: {
        type: Boolean,
        required: false,
        default: function () {
          return false
        }
      },
      cpntMensagem: {
        type: String,
        required: false,
        default: null
      },
      cpntPlaceholder: {
        type: String,
        required: false,
        default: ''
      },
      cpntMensagemTipo: {
        type: String,
        required: false,
        default: null
      },
      cpntFocus: {
        required: false,
        type: [ String, Number ],
        default: function () {
          return ''
        }
      },
      cpntOn: {
        type: String,
        required: false,
        default: 'Sim'
      },
      cpntOff: {
        type: String,
        required: false,
        default: 'Não'
      },
      cpntClass: {
        type: String,
        required: false,
        default: 'fast'
      },
      cpntOnStyle: {
        type: String,
        required: false,
        default: 'primary' // default, primary, success, info, warning, danger
      },
      cpntOffStyle: {
        type: String,
        required: false,
        default: 'default' // default, primary, success, info, warning, danger
      },
      cpntSize: {
        type: String,
        required: false,
        default: 'small' // large, normal, small, mini
      },
      cpntWidth: {
        required: false
      },
      cpntExplica: {
        type: Object,
        required: false
      },
      cpntClassDivField: {
        required: false,
        type: [ String, Array ],
        default: function () {
          return []
        }
      },
      cpntMask: {
        required: false,
        validator: function (mask) {
          // INICIA O VETOR DE VALORES VALIDOS
          var vetor = [ 'data', 'data-hora', 'data-time' ]

          // VERIFICA SE A MASCARA TEM UM VALOR VALIDO
          if (vetor.indexOf(mask) === -1) {
            // REMOVE OS VALORES NÃO VALIDOS PARA MENSAGEM
            vetor = vetor.filter(item => [ '', null, undefined ].indexOf(item) === -1)

            // APRESENTA A MENSAGEM DE ERRO
            throw new Error('O valor (' + mask +') informado na chave cpntMask é inválido. Os valores validos são [ ' + vetor.join(', ') + ' ].')
          }
          
          // RETORNA QUE A MASCARA É VALIDA
          return true
        },
        default: function () {
          return 'data'
        }
      },
      cpntConfig: {
        required: false,
        default: function () {
          return {}
        }
      },

      cpntOnKeyPressEnter: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntOnChange: {
        required: true,
        default: function () {
          return null
        }
      },
      cpntOnBlur: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue'),
      TheMask
    },
    data: function () {
      return {
        input: null,
        value: '',
        loading: false
      }
    },
    mounted: function () {
      this.cpntCalendarioIniciar()
    },
    destroyed: function () {
      $('.datepick-popup').remove()
    },
    methods: {
      cpntCalendarioIniciar: function () {
        if (this.input === null) {
          // PEGA O CAMPO SOLICITADO
          var input = this.$refs.input.$el !== undefined ? this.$refs.input.$el : this.$refs.input

          // SETA O CAMPO QUE TERÁ O SELECT2
          this.input = $(input)

          // SETA O VALOR DO CAMPO
          this.value = this.cpntValue

          // SETA AS CONFIGURAÇÕES DO PLUGIN
          var config = Object.assign({
            dateFormat: 'dd/mm/yyyy',
            onSelect: (dates) => {
              // PEGA O VALOR RECEBIDO E FORMATA
              var value = $.datepick.formatDate(dates[0])

              // MANDA ATUALIZAR O CAMPO
              this.cpntCalendarioOnChange(value)
            }, 
          }, JSON.parse(JSON.stringify(this.cpntConfig)))
  
          // INICIA O CMAPO
          this.input.datepick(config)

          // CRIA OS OBSERVADORES DO CAMPO
          this.cpntCalendarioCriarObservadores()
        }
      },
      cpntCalendarioOnChange: function (value) {
        if (value !== this.cpntValue) {
          // SETA O VALOR DO CAMPO
          this.value = value

          // CHAMA A FUNÇÃO PARA ATUALIZAR O CAMPO
          this.cpntOnChange(value, this.cpntId)
        }
      },
      cpntRealizarFocus: function (tentativa = 0) {
        if (tentativa <= 10) {
          if (this.cpntMostrar === true && this.loading === false) {
            // PEGA O CAMPO SOLICITADO
            var input = this.$refs.input.$el !== undefined ? this.$refs.input.$el : this.$refs.input
    
            // REALIZA O FOCUS NO CAMPOS
            input.select()

            // // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
            // const FUN_POSICIONAR_SCROLL_FOCUS_CAMPO = require('@/assets/js/Funcoes-Gerais.js').FUN_POSICIONAR_SCROLL_FOCUS_CAMPO

            // // EXECUTA A FUNÇÃO IMPORTADA
            // FUN_POSICIONAR_SCROLL_FOCUS_CAMPO(input)
          } else {
            setTimeout(() => { this.cpntRealizarFocus((tentativa + 1)) }, 250)
          }
        }
      },
      cpntCalendarioOnBlur: function () {
        // MANDA ATUALIZAR O VALOR DO CAMPO
        this.cpntCalendarioOnChange(this.value)

        // VERIFICA SE TEM FUNÇÃO BLUR
        if (this.cpntOnBlur !== null) {
          this.cpntOnBlur(this.cpntId)
        }
      },
      cpntCalendarioCriarObservadores: function (tentativa = 0) {
        if (tentativa <= 5 && [ '', null, undefined, 'numero_decimal', 'valor', 'valorMoeda' ].indexOf(this.cpntMask) === -1) {
          if ([ '', null, undefined ].indexOf(this.$refs.input) !== -1 || [ '', null, undefined ].indexOf(this.$refs.input.$el) !== -1) {            
            setTimeout(() => { this.cpntCalendarioCriarObservadores((tentativa + 1)) }, 100)
          } else {
            // SETA A OPÇÃO KEY UP
            this.$refs.input.$el.addEventListener('keyup', this.cpntCalendarioSetarOnKeyUp)

            // // SETA A OPÇÃO BLUR
            // this.$refs.input.$el.addEventListener('blur', this.cpntCalendarioOnBlur)
          }
        }
      },
      cpntCalendarioSetarOnKeyUp: function (event) {
        switch (event.key) {
          case 'Enter':
            this.cpntCalendarioOnKeyPressEnter()
            break
        }
      },
      cpntCalendarioOnKeyPressEnter: function () {
        if (this.cpntOnKeyPressEnter !== null) {
          this.cpntOnKeyPressEnter(this.cpntId)
        }
      }
    },
    computed: {
      cpntCalendarioMontarClass: function () {
        // INICIA O VALOR QUE SERÁ RETORNADO
        var valor = []

        // VERIFICA SE TEM ALGUMA MENSAGEM DE VALIDAÇÃO
        if ([ '', null, undefined ].indexOf(this.cpntMensagem) === -1) {
          valor.push('cpnt-app-campo-has-error')
        }

        // VERIFICA SE É FILTRO ESTE CAMPO
        if (this.cpntFiltro === true) {
          valor.push('cpnt-filtros')
        }
        
        // RETORNA O VALOR MONTADO
        return valor
      }
    },
    watch: {
      cpntValue: function () {
        if (this.cpntValue !== this.value) {
          this.value = this.cpntValue

        }
      }
    }
  }
</script>
